<template>
  <div class="input-section-wrapper">
    <h3 class="input-section-title">
      Additional Info
    </h3>
    <b-row
      class="w-100 margin-bottom-16"
      no-gutters
    >
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Country of Origin</span>
          </template>
          <custom-select
            id="country-dropdown"
            v-model="country"
            show-arrow-icon
            placeholder="Select the country of origin"
            no-data-text="No country found."
            theme="grey"
            size="small"
            :is-searchable="true"
            :is-selection-removable="false"
            :should-scroll-on-focus="true"
            :close-on-select="true"
            :option-groups="countryOptions"
            @select="(newCountry) => country = newCountry"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">HS Code</span>
          </template>
          <b-form-input
            v-model="hscode"
            placeholder="Enter HS Code"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      class="w-100 margin-bottom-16"
      no-gutters
    >
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Shipping Start Date</span>
          </template>
          <b-form-datepicker
            v-model="shippingStartDate"
            dropleft
            value-as-date
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="en-GB"
            placeholder="Enter Shipping Start Date"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Shipping End Date</span>
          </template>
          <b-form-datepicker
            v-model="shippingEndDate"
            dropleft
            value-as-date
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="en-GB"
            placeholder="Enter Shipping End Date"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      class="w-100 margin-bottom-16"
      no-gutters
    >
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Lines</span>
          </template>
          <b-form-input
            v-model="lines"
            placeholder="Enter Lines"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Sub Lines</span>
          </template>
          <b-form-input
            v-model="subLines"
            placeholder="Enter Sub lines"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      class="w-100 margin-bottom-16"
      no-gutters
    >
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Groups</span>
          </template>
          <b-form-input
            v-model="groups"
            placeholder="Enter Groups"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Sub Groups</span>
          </template>
          <b-form-input
            v-model="subGroups"
            placeholder="Enter Sub groups"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      class="w-100 margin-bottom-16"
      no-gutters
    >
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Keywords (comma separated)</span>
          </template>
          <b-form-tags
            ref="keywordsTag"
            v-model="keywords"
            separator=","
            tag-class="custom-tag"
            remove-on-delete
            duplicate-tag-text="Duplicate keyword"
            invalid-tag-text=""
            :placeholder="!keywords || keywords.length === 0 ? `Add keywords (comma separated)` : ''"
            input-id="keywords-input"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Key Styles</span>
          </template>
          <b-form-input
            v-model="keyStyles"
            placeholder="Enter Key Styles"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      class="w-100 margin-bottom-16"
      no-gutters
    >
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Recommended Items (comma separated)</span>
          </template>
          <b-form-tags
            ref="recommendedItemsTag"
            v-model="recommendedItems"
            separator=","
            tag-class="custom-tag"
            remove-on-delete
            duplicate-tag-text="Duplicate keyword"
            invalid-tag-text=""
            :placeholder="!recommendedItems || recommendedItems.length === 0 ? `Add recommended items (comma separated)` : ''"
            input-id="recommended-items-input"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="reduce-padding"
      >
        <b-form-group
          class="input-form-group"
        >
          <template #label>
            <span class="input-label">Product Order</span>
          </template>
          <ValidationProvider
            v-slot="{ errors, touched }"
            name="Product Order"
            rules="numeric"
          >
            <b-form-input
              v-model="orderIndex"
              type="text"
              placeholder="Enter Product Order"
              :class="{ 'is-invalid': touched && errors.length }"
              @keypress="onlyAllowPositiveInteger"
              @paste="blockInvalidIntegerPaste"
            />
            <div class="error-section">
              <small class="text-danger">{{ errors[0] }}</small>
            </div>
          </ValidationProvider>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormTags, BFormDatepicker,
} from 'bootstrap-vue'
import CustomSelect from '@/@core/components/custom-select/CustomSelect.vue'
import store from '@/store'
import { GET_COUNTRIES } from '@/store/modules/common.module'
import { apiToastError } from '@/@core/utils/toast'
import {
  blockInvalidIntegerPaste,
  onlyAllowPositiveInteger,
} from '@/views/apps/product/edit/utils'
import { ValidationProvider } from 'vee-validate'
import { useAdditionalInfo } from './hooks/useAdditionalInfo'

export default {
  name: 'AdditionalInfo',
  components: {
    ValidationProvider,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTags,
    CustomSelect,
    BFormDatepicker,
  },
  data() {
    return {
      countryOptions: [{
        title: '',
        options: [],
      }],
    }
  },
  created() {
    this.getAllCountries()
  },
  mounted() {
    this.setupTagEventListeners('add')
  },
  beforeDestroy() {
    this.setupTagEventListeners('remove')
  },
  methods: {
    onlyAllowPositiveInteger,
    blockInvalidIntegerPaste,
    setupTagEventListeners(action) {
      const tagRefs = ['keywordsTag', 'recommendedItemsTag']
      tagRefs.forEach(refName => {
        const tagRef = this.$refs[refName]
        if (tagRef && tagRef.$refs.input) {
          if (action === 'add') {
            tagRef.$refs.input.addEventListener('blur', this.handleTagFocusOut)
          } else if (action === 'remove') {
            tagRef.$refs.input.removeEventListener('blur', this.handleTagFocusOut)
          }
        }
      })
    },
    getAllCountries() {
      store.dispatch(GET_COUNTRIES).then(res => {
        this.allCountries = res.data.data.COUNTRIES
        this.countryOptions = [{
          title: '',
          options: this.allCountries,
        }]
      }).catch(() => {
        apiToastError('Sorry, we couldn’t load the list of countries. Please try again shortly.')
      })
    },
    handleTagFocusOut(event) {
      const input = event.target
      if (input && input.value) {
        input.dispatchEvent(new KeyboardEvent('keydown', {
          key: 'Enter',
          keyCode: 13,
          code: 'Enter',
          which: 13,
        }))
        input.blur()
      }
    },
  },
  setup() {
    const {
      country,
      hscode,
      lines,
      subLines,
      groups,
      subGroups,
      orderIndex,
      shippingStartDate,
      shippingEndDate,
      keywords,
      recommendedItems,
      keyStyles,
    } = useAdditionalInfo()
    return {
      country,
      hscode,
      lines,
      subLines,
      groups,
      subGroups,
      orderIndex,
      shippingStartDate,
      shippingEndDate,
      keywords,
      recommendedItems,
      keyStyles,
    }
  },
}
</script>
<style lang="scss">

</style>
